<template>
    <v-overlay color="#000" opacity="0.40" v-show="loadingDialog.open" :z-index="loadingDialog.zIndex">
        <v-card width="500" class="text-center mt-n100px card">
          <v-progress-circular class="mb-20px" indeterminate color="primary" :size="25" :width="2" />
          <text-group
            invert
            large
            :utext="loadingDialog.utext"
            :btext="loadingDialog.btext"
            :gap="5"
          ></text-group>
        </v-card>
      </v-overlay>
  </template>
  <script>
  import { mapGetters } from 'vuex';
  import TextGroup from './TextGroup.vue';

  export default {
    components:{
      TextGroup
    },
    computed: {
      ...mapGetters(['loadingDialog']),
    },

  };
  </script>
  